export default __webpack_public_path__ + "static/media/sanmartino.e0d5bc18.png";